import React, { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import {
  emptyDonut,
  getTotalValue,
  primaryColor,
  tooltipContentStyle,
} from "utils/dashboardUtils";
import DisplayPrice from "components/common/DisplayPrice";


const TotalRevenue = ({revenueData}) => {
  const { t } = useTranslation();

  
  const TOTAL_REVENUE_DATA = {
    total: revenueData?.total,
    donut: [
      { label: t("Membership"), value: revenueData?.membershipPercent, color: primaryColor },
      { label: t("One Time Wash"), value: revenueData?.oneTimeWashPercent, color: "#F3AA41" },
      { label: t("Interior Add on"), value: revenueData?.addonsPercent, color: "#523677" },
    ],
  };
  const { total, donut } = TOTAL_REVENUE_DATA;
  const [activeValue, setActiveValue] = useState(donut[0].value);

  const totalValue = getTotalValue(donut);

  const chartData = totalValue === 0 ? emptyDonut : donut;

  return (
    <div className="sentiment_card dashboard_common_card">
      <h3 className="fs_20">{t("Total Revenue")}</h3>

      {/* Donut */}
      <div className="sentiment_chart">
        <ResponsiveContainer width={175} height={175}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="label"
              innerRadius={60}
              outerRadius={80}
              startAngle={90}
              endAngle={-270}
              stroke="none"
              onMouseEnter={(_, index) => setActiveValue(donut[index].value)}
              onMouseLeave={() => setActiveValue(donut[0].value)}
            >
              {chartData.map((item, index) => (
                <Cell key={index} fill={item.color} />
              ))}
            </Pie>

            {totalValue > 0 && (
              <Tooltip
                formatter={(value, name) => [`${value}%`, t(name)]}
                cursor={false}
                contentStyle={tooltipContentStyle}
              />
            )}
          </PieChart>
        </ResponsiveContainer>

        <div className="sentiment_center">
          {totalValue === 0 ? (
            <p>{t("No Revenue")}</p>
          ) : (
            <>
              <DisplayPrice
                value={total}
                width="14"
                height="15"
                color="#0F0F0F"
              />
              <p>{t("Revenue")}</p>
            </>
          )}
        </div>
      </div>

      {/* Breakdown (reuse animated bars) */}
      <div className="sentiment_breakdown">
        {donut.map((item) => (
          <div key={item.label} className="sentiment_row">
            <div className="sentiment_row__top">
              <span>{t(item.label)}</span>
              <span>{item.value}%</span>
            </div>

            <div className="sentiment_bar">
              <span
                className="sentiment_bar__fill"
                style={{
                  "--target-width": `${item.value}%`,
                  background: item.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TotalRevenue;
